import React, { useContext, useEffect, useState } from 'react';

import { Form, Col, Row } from "react-bootstrap";

import ComplementContext from "../../../context/Complement/ComplementContext"


import Loading from "../../../components/Loading"

const FormLiquidation = ({value, setValue, onChange, file, setFile}) => {
    const complementContext = useContext(ComplementContext);
    const {loadPeriod, periods, getPeriods} = complementContext;

    const [ years, setYears ] = useState([]);
    const [ filterPeriod, setfilterPeriod ] = useState([]);

    useEffect(() => {
        if(!periods) {
            getPeriods();
        }else{
            let result = periods.reduce(function (r, a) {
                        r[a.year] = r[a.year] || [];
                        r[a.year].push(a);
                        return r;
                        }, Object.create(null));
            let objYear = Object.keys(result);
            setYears(objYear)
            let period = periods.filter(period => period.year === parseInt(objYear[0]))
            setfilterPeriod(period)    
            
         //   setValue({...value, period: period[0].id})
       
        }
        // eslint-disable-next-line
    }, [periods])
 
    const filteringPeriod = (e) => {
        let year = e.target.value;
        setfilterPeriod(periods.filter(period => period.year === parseInt(year)))
    }


    return ( 
        <>            
            <Form>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                        Seleccione Año
                    </Form.Label>
                    <Col sm={2}>
                        {loadPeriod ? <Loading/> :
                            <Form.Control as="select" custom name="year" onChange={filteringPeriod}  required={true}>
                                {years.map(year => (
                                    <option 
                                        value={year} 
                                        >
                                            {year}
                                        </option>
                                ))}
                            </Form.Control>
                        }
                    </Col>

                    
                    <Form.Label column sm={2}>
                        Seleccione Periodo
                    </Form.Label>
                    <Col sm={2}>
                        {loadPeriod ? <Loading/> :
                            <Form.Control as="select" custom name="period" onChange={onChange} required={true}>
                                <option selected="selected" value="">Seleccionar...</option>
                                {filterPeriod.map( period => {
                                    return <option 
                                        value={period.id}
                                        >
                                        {period.name}
                                        </option>
                                })}
                            </Form.Control>
                        }
                    </Col>


                    <Col sm={3}>
                    <input type="file" 
                        name="liquidation"
                        value={file.filename}
                        onChange={(e)=>{setFile(e.target.files[0])}}
                       
                        accept={'.pdf'}
                    />
                    </Col>               
                   
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Comentario</Form.Label>
                    <Form.Control as="textarea" rows={12} maxLength={200} name="description" onChange={onChange}/>
                </Form.Group>
            </Form>
        </>
     );
}
 
export default FormLiquidation;